import Component, { ComponentAttrs } from 'flarum/common/Component';
import Mithril from 'mithril';
import Link from 'flarum/common/components/Link';
import app from 'flarum/forum/app';
import { SingleTopRatedUserAttrs } from './types';

export default class SingleTopRatedUser extends Component<SingleTopRatedUserAttrs> {
  oninit(vnode: Mithril.Vnode<ComponentAttrs, this>) {
    super.oninit(vnode);
  }

  view(vnode: Mithril.Vnode<ComponentAttrs, this>): Mithril.Children {
    return (
      <Link href={this.attrs.userLink}>
        <div className="DiscussionListItem">
          <div className="DiscussionListItem-content Slidable-content unread">
            <div className="DiscussionListItem-author">
              <img class="Avatar" loading="lazy" src={this.attrs.avatarUrl} alt="" />
            </div>
            <div class="DiscussionListItem-main">
              <h2 class="DiscussionListItem-title">{this.attrs.username}</h2>
              <ul class="DiscussionListItem-info">
                <li class="item-tags">
                  <span class="TagsLabel">
                    <span class="TagLabel  colored text-contrast--dark" style="--tag-bg: #04af2f;">
                      <span class="TagLabel-text">
                        <i class="TagLabel-icon icon fas fa-crown" aria-hidden="true"></i>
                        <span class="TagLabel-name">{app.translator.trans('justoverclock-reputation-score.forum.topReputation')}</span>
                      </span>
                    </span>
                  </span>
                </li>
                <li class="item-terminalPost">
                  <span>
                    <span class="username">
                      {app.translator.trans('justoverclock-reputation-score.forum.reputation')}: {this.attrs.reputation}
                    </span>
                    <span class="username trust-info">
                      {app.translator.trans('justoverclock-reputation-score.forum.discussionCount')}: {this.attrs.discussionCount}
                    </span>
                    <span class="username trust-info">
                      {app.translator.trans('justoverclock-reputation-score.forum.totalPosts')}: {this.attrs.commentCount}
                    </span>
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </Link>
    );
  }
}
